export const magazines = {
  '@odata.context':
    "https://jellyfish-search.search.windows.net/indexes('magazinecouk-search')/$metadata#docs(type,title,id,url,redirect,term,image,desc,offerProductType,offerName,offerSave,offerProductId,offerPaymentType,offerSku,offerPrice,offerCpa,isDelete)",
  '@odata.count': 15,
  value: [
    {
      '@search.score': 2,
      desc: 'Are you ready to kickstart your health and fitness journey? Learn how to make the lifestyle changes that are best for you with a monthly dose of motiv',
      id: 'p_6947',
      image: '/products/womens-fitness-magazine-2-cover.jpg',
      isDelete: 0,
      offerCpa: '12.50',
      offerName: '6 issues for £12.00',
      offerPaymentType: 'DD',
      offerPrice: 12,
      offerProductId: 10413,
      offerProductType: 'PRINT',
      offerSave: 50,
      offerSku: '8512',
      redirect: '',
      term: 'womens fitness',
      title: "Women's Fitness",
      type: 'magazine',
      url: 'magazines/womens-fitness-magazine'
    },
    {
      '@search.score': 2,
      desc: 'Helping you to celebrate and build your mind, body and soul, Women&#39;s Health&nbsp;magazine&nbsp;is created for women who want the very best in heal',
      id: 'p_3109',
      image: '/products/womens-health-magazine-cover.jpg',
      isDelete: 0,
      offerCpa: '11.00',
      offerName: '5 issues for £15.00',
      offerPaymentType: 'DD',
      offerPrice: 15,
      offerProductId: 10756,
      offerProductType: 'PRINT',
      offerSave: 40,
      offerSku: '8832',
      redirect: '',
      term: '',
      title: "Women's Health",
      type: 'magazine',
      url: 'magazines/womens-health-magazine'
    },
    {
      '@search.score': 2,
      desc: 'Whether you’re a complete beginner or a professional pacemaker, stay-at-home mum or career driven professional, Women’s Running magazine is loaded',
      id: 'p_3125',
      image: '/products/womens-running-magazine-cover.jpg',
      isDelete: 0,
      offerCpa: '15.00',
      offerName: '3 issues for £11.99',
      offerPaymentType: 'DD',
      offerPrice: 12,
      offerProductId: 13439,
      offerProductType: 'PRINT',
      offerSave: 20,
      offerSku: '11466',
      redirect: '',
      term: '',
      title: "Women's Running",
      type: 'magazine',
      url: 'magazines/womens-running-magazine'
    },
    {
      '@search.score': 1,
      desc: 'Woman is the must-have weekly features and fashion magazine that inspires 40-plus women to discover new ideas and inspiration. Woman recognises the re',
      id: 'p_13947',
      image: '/products/woman-magazine-cover.jpg',
      isDelete: 0,
      offerCpa: null,
      offerName: null,
      offerPaymentType: null,
      offerPrice: null,
      offerProductId: null,
      offerProductType: null,
      offerSave: null,
      offerSku: null,
      redirect: '',
      term: '',
      title: 'Woman',
      type: 'magazine',
      url: 'magazines/woman-magazine'
    }
  ]
}

export const categories = {
  '@odata.context':
    "https://jellyfish-search.search.windows.net/indexes('magazinecouk-search')/$metadata#docs(id,title,titleToLower,path,category_id,category,category1,category2,url,isDelete,level,type)",
  value: [
    {
      '@search.text': 'For <b>Women</b>',
      category: 'For Women',
      category1: 'For Women',
      category2: null,
      category_id: 4,
      id: 'c_4',
      isDelete: 0,
      level: 2,
      path: '1/2/4',
      title: 'For Women',
      titleToLower: 'for women',
      type: 'category',
      url: 'magazine-subscriptions-for-women'
    },
    {
      '@search.text': "<b>Women's</b> Lifestyle",
      category: "Lifestyle / Women's Lifestyle",
      category1: 'Lifestyle',
      category2: "Women's Lifestyle",
      category_id: 82,
      id: 'c_82',
      isDelete: 0,
      level: 3,
      path: '1/2/60/82',
      title: "Women's Lifestyle",
      titleToLower: "women's lifestyle",
      type: 'category',
      url: 'lifestyle-magazines/women-s-lifestyle'
    },
    {
      '@search.text': "<b>Women's</b> Fashion",
      category: "Fashion & Beauty / Women's Fashion",
      category1: 'Fashion & Beauty',
      category2: "Women's Fashion",
      category_id: 9,
      id: 'c_9',
      isDelete: 0,
      level: 3,
      path: '1/2/8/9',
      title: "Women's Fashion",
      titleToLower: "women's fashion",
      type: 'category',
      url: 'fashion-and-beauty-magazines/women-s-fashion'
    },
    {
      '@search.text': "<b>Women's</b> Best Selling",
      category: "Best Selling / Women's Best Selling",
      category1: 'Best Selling',
      category2: "Women's Best Selling",
      category_id: 14,
      id: 'c_14',
      isDelete: 0,
      level: 3,
      path: '1/2/12/14',
      title: "Women's Best Selling",
      titleToLower: "women's best selling",
      type: 'category',
      url: 'best-selling-magazine-subscriptions/women-s-best-selling'
    }
  ]
}
